module.exports = require('../input').extend
  template: require('./index.pug')

  props:
    rows: { default: 3 }


// WEBPACK FOOTER //
// ./assets/js/frontend/components/form/textarea/index.coffee